import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from "./pages/login/login.component";
import { BasicLayoutComponent } from "./module/layout/basic-layout/basic-layout.component";
import { AuthGuard } from "./guards/auth.guard";
import { NotFoundPageComponent } from "./pages/not-found-page/not-found-page.component";
import { BlankLayoutComponent } from "./module/layout/blank-layout/blank-layout.component";
import { LoginRedirectionComponent } from "./pages/login-redirection/login-redirection.component";
import { RouterGuardGuard } from './guards/router-guard.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'loginRedirect' },
  { path: 'loginRedirect', component: LoginRedirectionComponent },
  { path: 'login', component: LoginComponent },
  {   
    path: '',     
    component: BasicLayoutComponent,
    canActivate: [AuthGuard, RouterGuardGuard],
    children: [     
      { path: 'yc', loadChildren: () => import('./pages/yc/yc.module').then(m => m.YCModule)},
      { path: 'psi', loadChildren: () => import('./pages/management/management.module').then(m => m.ManagementModule)},
      { path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule) },
      { path: 'report', loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule) },
      { 
        path: 'tenant',
        component: BlankLayoutComponent,
        // data: { breadcrumb: '系统配置' },
        loadChildren: () => import('./pages/tenant/tenant.module').then(m => m.TenantModule)
      },
      { path: 'tag', loadChildren: () => import('./module/tag/tag.module').then(m => m.TagModule) },
      { path: 'system', loadChildren: () => import('./module/sysDataModel/sys-data-model.module').then(m => m.SysDataModelModule) },
      { path: 'dashboard', loadChildren: () => import('projects/dashboard-library/src/public-api').then(m => m.DashboardLibraryModule)},
    ]    
  },  
  { path: '**', component: NotFoundPageComponent}
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
